export default __webpack_public_path__ + "static/media/rewards.72a11479.png";